import { createAction } from '@reduxjs/toolkit';

export const SET_STORE_MUSIC_REF = 'SET_STORE_MUSIC_REF';
export const SET_STORE_MUSIC_PLAY_STATE = 'SET_STORE_MUSIC_PLAY_STATE';
export const PUSH_TO_MEDIA_STACK = 'PUSH_TO_MEDIA_STACK';
export const SET_PERSIST_STACK_ON_SCENE_CHANGE =
	'SET_PERSIST_STACK_ON_SCENE_CHANGE';
export const POP_FROM_MEDIA_STACK = 'POP_FROM_MEDIA_STACK';
export const CLEAR_MEDIA_STACK = 'CLEAR_MEDIA_STACK';

export const setStoreMusicRef = createAction(SET_STORE_MUSIC_REF);
export const setStoreMusicPlayState = createAction(SET_STORE_MUSIC_PLAY_STATE);

// stack fns
export const pushToMediaStack = createAction(PUSH_TO_MEDIA_STACK);
export const popFromMediaStack = createAction(POP_FROM_MEDIA_STACK);
export const clearMediaStack = createAction(CLEAR_MEDIA_STACK);
export const setPersistOnStateChange = createAction(
	SET_PERSIST_STACK_ON_SCENE_CHANGE,
);
